module.exports = __webpack_public_path__ + "img/68c18d3.jpg";